//#region src/dom/keybinds.ts
/**
* {@link Keybinds} function that maps set of default `keydown` keybinds to {@link NavigationAction}:
*
* Default keybinds:
* - Arrow keys → {@link MoveAction}
* - Enter / Space → {@link ActivateAction}
* - Backspace → {@link MoveAction} with direction `"back"`
*/
function defaultKeybinds(e, options = {}) {
	const { longpress } = options;
	const key = getKey(e);
	if (key == null) return null;
	if (key === "Enter" || key === " ") return {
		kind: "activate",
		longpress
	};
	if (key === "ArrowUp") return {
		kind: "move",
		direction: "up",
		longpress
	};
	if (key === "ArrowDown") return {
		kind: "move",
		direction: "down",
		longpress
	};
	if (key === "ArrowLeft") return {
		kind: "move",
		direction: "left",
		longpress
	};
	if (key === "ArrowRight") return {
		kind: "move",
		direction: "right",
		longpress
	};
	if (key === "Backspace") return {
		kind: "move",
		direction: "back",
		longpress
	};
	return null;
}
function getKey(e) {
	if ("key" in e && typeof e.key === "string") return e.key;
	return null;
}
//#endregion
export { defaultKeybinds, getKey };

//# sourceMappingURL=keybinds.js.map